import { render, staticRenderFns } from "./StockTrackingAddPalletItems.vue?vue&type=template&id=1810dc78&scoped=true&"
import script from "./StockTrackingAddPalletItems.vue?vue&type=script&lang=js&"
export * from "./StockTrackingAddPalletItems.vue?vue&type=script&lang=js&"
import style0 from "./StockTrackingAddPalletItems.vue?vue&type=style&index=0&id=1810dc78&lang=scss&scoped=true&"
import style1 from "./StockTrackingAddPalletItems.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810dc78",
  null
  
)

export default component.exports